"use client";
import React from "react";
import PropTypes from "prop-types";
import Skeleton from "../../molecules/skeletons/skeleton";

/**
 * Loading placeholder for the feed region inside the default search dropdown.
 *
 * @param {Object} props
 * @param {boolean} [props.isMobile] - Tighter layout on mobile search drawer
 * @returns {React.ReactElement}
 */
const DefaultSearchFeedSkeleton = ({ isMobile = false }) => {
  const bannerHeight = isMobile ? 140 : 160;

  return (
    <div className="flex w-full flex-col px-16 pt-8" aria-busy="true" aria-label="Loading search suggestions">
      <Skeleton variant="rounded" animation="pulse" customStyle={{ height: bannerHeight, width: "100%" }} />
      <div className="mt-16 flex gap-8 overflow-hidden">
        {Array.from({ length: isMobile ? 3 : 5 }, (_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            animation="pulse"
            customStyle={{ height: isMobile ? 72 : 88, width: isMobile ? 72 : 96, flexShrink: 0 }}
          />
        ))}
      </div>
      <div className="mt-20">
        <Skeleton variant="rounded" animation="pulse" customStyle={{ height: 16, width: 140 }} />
      </div>
      <div className="mt-12 grid grid-cols-2 gap-12 md:grid-cols-3">
        {Array.from({ length: isMobile ? 2 : 3 }, (_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            animation="pulse"
            customStyle={{ height: isMobile ? 100 : 120, width: "100%" }}
          />
        ))}
      </div>
    </div>
  );
};

DefaultSearchFeedSkeleton.propTypes = {
  isMobile: PropTypes.bool,
};

export default DefaultSearchFeedSkeleton;
